import(/* webpackMode: "eager" */ "C:\\cin-project\\Orange_Tiger_Nextjs\\src\\app\\[brandSlug]\\[propertySlug]\\[citySlug]\\offers\\page.js");
